export default __webpack_public_path__ + "static/media/logoDesktop3x.fbb02e58.png";